import { render } from "./CompanyCommunication.vue?vue&type=template&id=c22f05c6"
import script from "./CompanyCommunication.vue?vue&type=script&lang=js"
export * from "./CompanyCommunication.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__